/**
 * Houdt de statiegeldregel gelijk aan het aantal flessen (README §6.6), en ruimt
 * de cadeauverpakking op zodra de wagen verder leeg is.
 *
 * Liquid geeft door wat er staat (`data-huidig`: variant:aantal per regel) en
 * wat er hoort te staan (`data-doel`). Wijkt dat af, dan zet één cart/update.js
 * het recht en gaat het standaard-event de deur uit, zodat lade, pagina en
 * teller opnieuw renderen. De herrender levert gelijke waarden, dus het stopt
 * vanzelf. Eén globale vlag voorkomt dat lade en pagina tegelijk aan het werk
 * gaan.
 *
 * Horizons morph houdt dit element bij een herrender in leven en werkt alleen
 * de attributen bij; connectedCallback komt dan niet nog eens. Daarom kijkt het
 * element ook naar attribuutwijzigingen, één microtask later zodat beide
 * attributen al gesynchroniseerd zijn.
 */

import { zetAantallen } from '@theme/smokkelaar-cart';

const lees = (s) =>
  (s || '')
    .split(',')
    .filter(Boolean)
    .map((p) => p.split(':'))
    .map(([id, n]) => [id, Number(n)]);

class SmokkelaarStatiegeld extends HTMLElement {
  static observedAttributes = ['data-doel', 'data-huidig'];

  #gepland = false;

  connectedCallback() {
    this.#controleer();
  }

  attributeChangedCallback() {
    if (this.#gepland || !this.isConnected) return;
    this.#gepland = true;
    queueMicrotask(() => {
      this.#gepland = false;
      this.#controleer();
    });
  }

  #controleer() {
    const huidig = lees(this.dataset.huidig);
    const doel = lees(this.dataset.doel);
    const klopt =
      huidig.length === doel.length && huidig.every(([id, n]) => doel.some(([d, m]) => d === id && m === n));
    if (klopt || window.smokkelaarStatiegeldBezig) return;
    window.smokkelaarStatiegeldBezig = true;

    const updates = {};
    for (const [id] of huidig) updates[id] = 0;
    for (const [id, n] of doel) updates[id] = n;

    // Gaat de cadeauverpakking eruit, dan ook het vinkje en het kaartje.
    const opties = { bron: this };
    const cadeau = this.dataset.cadeauVariant;
    if (cadeau && updates[cadeau] === 0) opties.attributes = { cadeau: '', kaartje: '' };

    // action 'update', nooit 'add': anders zou de lade bij het laden van de
    // pagina opengaan als het statiegeld nog rechtgezet moet worden.
    zetAantallen(updates, opties)
      .catch((err) => console.error('Statiegeld:', err))
      .finally(() => { window.smokkelaarStatiegeldBezig = false; });
  }
}

if (!customElements.get('smokkelaar-statiegeld')) {
  customElements.define('smokkelaar-statiegeld', SmokkelaarStatiegeld);
}
